// import { sbaasLegacyPreset } from '@swuif/sbaas';
import { sbaasLegacyPreset } from '@/components/custom/sbaas/src/legacy';

import appLogo from '@/assets/logo.svg';
// import antdEn from 'antd/es/locale-provider/en_US';
// import antdId from 'antd/es/locale-provider/id_ID';
import i18n from './i18n';
import { authLocalStorage } from 'swuif';

/**
 * Create a preset for SBaaS consuming application.
 * `sbaasPreset` is for SBaaS version >= 1.0.0.
 * For SBaaS version < 1.0.0 use `sbaasLegacyPreset` instead.
 */
export const auth1 = authLocalStorage();

const { app, http, sbaas } = sbaasLegacyPreset({
  auth: {
    storage: auth1,
  },
  sbaas: {
    base: process.env.REACT_APP_SBAAS_BASE!,
    app: process.env.REACT_APP_SBAAS_APP!,
  },
  config: {
    app: {
      appName: 'SC-WEBVIEW',
      appLogo,
    },
    locale: {
      i18n,
      fallbackLanguage: 'en',
      // languageMeta: {
      //   en: {
      //     antd: antdEn,
      //     countryFlag: 'gb',
      //     label: 'English',
      //   },
      //   id: {
      //     antd: antdId,
      //     countryFlag: 'id',
      //     label: 'Bahasa Indonesia',
      //   },
      // },
    },
  },
});

export { app, http, sbaas };
